import Markdown from "react-markdown";
import Privacy from "./privacypolicy.md?raw";
import remarkGfm from "remark-gfm";

export const PrivacyPolicy = () => {
	return (
		<div className="sm:w-2/3 place-self-center text-lg [&>*]:p-4 [&>*]:text-justify [&>ul]:list-disc [&>ul]:mx-4 [&>table]:border-solid [&>table]:border-2 [&>table]:mx-6 [&_th]:border-solid [&_th]:border-2 [&_th]:border-collapse [&_td]:border-solid [&_td]:border-2 [&_td]:border-collapse">
			<Markdown remarkPlugins={[remarkGfm]}>{Privacy}</Markdown>
		</div>
	);
};
